<!-- 一个题目是一个卡片 -->
<!-- 隐私声明题目  -->
<template>
  <div class="privacy-card">
    <!-- 序号及标题 -->
    <p class="label">{{ seq | numFormmat }} {{ itemData.label }}</p>
    <!-- 隐私协议项集合 -->
    <div class="privacy-card__blocks">
      <vh-collapse v-model="activeCollapseName" accordion>
        <vh-collapse-item
          v-for="(option, index) in optionList"
          :key="`collapse_${option.id}`"
          :name="`${index}`"
          :disabled="disabled"
        >
          <!-- 折叠面标题自定义 -->
          <template slot="title" v-if="!disabled">
            <div style="flex: 1">第 {{ index + 1 }} 个</div>
            <i
              v-if="index > 0"
              @click.stop.prevent="handleRemove(option)"
              class="vh-tooltip iconfont-v3 saasicon-trash btn-remove"
            ></i>
          </template>
          <!-- 隐私协议项 -->
          <PrivacyBlock
            :value="option"
            :languageType="languageType"
            :key="option.id"
          ></PrivacyBlock>
        </vh-collapse-item>
      </vh-collapse>
      <vh-button
        v-if="optionList.length < 5"
        type="text"
        v-preventReClick
        style="margin-top: 10px"
        @click="handleAdd"
      >
        <i class="vh-icon-plus"></i>
        添加隐私声明
      </vh-button>
    </div>
    <!-- 勾选框开关 -->
    <div class="privacy-card__switch">
      <vh-switch
        class="swtich"
        size="mini"
        v-model="value.show_checkbox"
        :active-value="1"
        :inactive-value="0"
        active-color="#FB3A32"
        inactive-color="#CECECE"
        active-text="隐私声明显示勾选框，需要用户勾选后再提交"
      ></vh-switch>
    </div>
    <!-- 预览 -->
    <div class="privacy-card__preview">
      <PrivacyPreview
        :showTitle="true"
        :showCheckbox="value.show_checkbox"
        :optionList="optionList"
      />
    </div>
    <!-- 底部栏 -->
    <div class="privacy-card__footer">
      <vh-tooltip class="item" effect="dark" content="删除" placement="top" v-tooltipMove>
        <i class="iconfont-v3 saasicon-trash" @click="handleDelete"></i>
      </vh-tooltip>
    </div>
  </div>
</template>
<script>
  import PrivacyBlock from './PrivacyBlock.vue';
  import PrivacyPreview from './PrivacyPreview.vue';
  import RelatedConfig from './config';
  import { nanoid } from 'nanoid';
  import { options } from 'less';

  export default {
    name: 'PrivacyCard',
    components: {
      PrivacyBlock,
      PrivacyPreview
    },
    data() {
      return {};
    },
    props: {
      // 当前展开的折叠栏，都没有展开值为空字符串
      activeCollapse: {
        type: String,
        default: '0'
      },
      // 1 中文，2：英文, 默认为 1
      languageType: {
        type: [Number, String],
        default: 1
      },
      seq: Number,
      itemData: {
        type: Object,
        required: true,
        default() {
          return {};
        }
      },
      value: {
        type: Object,
        required: true,
        default() {
          return {};
        }
      }
    },
    computed: {
      activeCollapseName: {
        get() {
          console.log('this.activeCollapse:', this.activeCollapse);
          return this.activeCollapse;
        },
        set(value) {
          console.log('set activeCollapse:', value);
          // 触发自定义事件通知父组件
          this.$emit('update:activeCollapse', value);
        }
      },
      optionList() {
        return this.value.list || [];
      },
      disabled() {
        return this.optionList.length <= 1;
      },
      activeConfig() {
        return this.languageType == 2 ? RelatedConfig['en'] : RelatedConfig['zh'];
      }
    },
    filters: {
      numFormmat(val) {
        return val < 9 ? `0${val + 1}` : val + 1;
      }
    },
    methods: {
      // 删除整个隐私协议题目
      handleDelete() {
        this.$emit('on-delete', this.itemData.question_id, this.itemData);
      },
      // 删除一个隐私协议块
      async handleRemove(item) {
        this.$emit('on-remove', this.itemData.question_id, item);
      },
      // 添加一个隐私协议块
      handleAdd() {
        if (this.optionList.length >= 5) return;
        const val = {
          id: nanoid(),
          content: this.activeConfig.contentValue,
          is_must: 1,
          options: [
            {
              color_text: this.activeConfig.colorTextValue,
              url: ''
            }
          ]
        };
        this.$emit('on-add', this.itemData.question_id, val, this.itemData);
      },
      // 生成预览效果
      formatPrivacyPreview(item) {
        let text = item.content || '';
        const subOptions = item?.options || [];
        for (const sub of subOptions) {
          if (sub.color_text && sub.url) {
            let matchPrivacy = text.match(sub.color_text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
            if (matchPrivacy) {
              let joinstr = `<a href="${sub.url}" target="_blank">${matchPrivacy[0]}</a>`;
              text = text.split(matchPrivacy[0]).join(joinstr);
            }
          }
        }
        return text;
      }
    }
  };
</script>
<style lang="less" scoped>
  .privacy-card {
    &__blocks {
      margin-top: 16px;

      ::v-deep .vh-collapse-item.is-disabled .vh-collapse-item__header {
        height: 12px;
        line-height: 12px;
        .vh-collapse-item__arrow {
          display: none;
        }
      }

      .btn-remove {
        font-size: 18px;
        color: #666666;
        margin-left: 16px;
        cursor: pointer;
        margin-right: 10px;
      }
    }

    &__switch {
      padding: 16px 0 0 0;
    }

    &__footer {
      text-align: right;

      i {
        font-size: 18px;
        color: #666666;
        margin-left: 16px;
        cursor: pointer;

        &:hover {
          color: #1a1a1a;
        }
      }
    }
  }
</style>
